import React, { useCallback, useMemo } from "react";
import { LatLngLiteral } from "leaflet";
import { MapDrawOptions } from "../../pages/Alert/components/MapDrawOptions";
import { MapGeofence } from "../../pages/OceanWeatherIntelligence/InsightAlert/Components/MapGeofence";
import { MapAreaSelectorEmptyState } from "../../pages/Alert/components/MapAreaSelectorEmptyState";

export interface GeofenceMapSelectorProps {
  coordinates?: any[] | LatLngLiteral[];
  selectedGeofence?: LatLngLiteral[];
  t: (key: string) => string;
  handleDrawingMode?: (formValues?: any) => void;
  handleGeoJsonLoaded?: (geojson: any) => void;
  clearGeofence?: () => void;
  onCoordinatesChange?: (coordinates: LatLngLiteral[]) => void;
  setIsGeofenceLoadedByGeoJson?: (value: boolean) => void;
  formValues?: any;
  handleEnableAreaSelector?: (value: boolean) => void;
  areaSelectorVisible?: boolean;
  showSelectSavedAreaButton?: boolean;
  hideSaveAreaButtonOnMap?: boolean;
  isGeofenceInvalid?: boolean;
  isDropZoneVisible?: boolean;
  setIsDropZoneVisible?: (value: boolean) => void;
  setFieldValue?: (field: string, value: any, shouldValidate?: boolean) => void;
  isLocationLocked?: boolean;
}

export const GeofenceMapSelector: React.FC<GeofenceMapSelectorProps> = ({
  coordinates,
  selectedGeofence,
  t,
  handleDrawingMode,
  handleGeoJsonLoaded,
  clearGeofence,
  onCoordinatesChange,
  setIsGeofenceLoadedByGeoJson,
  formValues,
  handleEnableAreaSelector,
  areaSelectorVisible,
  showSelectSavedAreaButton,
  hideSaveAreaButtonOnMap = false,
  isGeofenceInvalid,
  isDropZoneVisible,
  setIsDropZoneVisible,
  setFieldValue,
  isLocationLocked = false,
}) => {
  const hasCoordinates = useMemo(
    () => Boolean(coordinates?.length),
    [coordinates]
  );

  const handleDrawingModeWithFormValues = useCallback(() => {
    if (!handleDrawingMode) return;

    if (formValues) {
      handleDrawingMode(formValues);
    } else {
      handleDrawingMode();
    }
  }, [handleDrawingMode, formValues]);

  const handleClearGeofence = useCallback(() => {
    clearGeofence?.();
    onCoordinatesChange?.([]);
  }, [clearGeofence, onCoordinatesChange]);

  return (
    <>
      {!hasCoordinates ? (
        areaSelectorVisible ? (
          <MapAreaSelectorEmptyState t={t} />
        ) : (
          <MapDrawOptions
            handleDrawingMode={handleDrawingModeWithFormValues}
            t={t}
            handleGeoJsonLoaded={handleGeoJsonLoaded}
            setIsGeofenceLoadedByGeoJson={setIsGeofenceLoadedByGeoJson}
            handleEnableAreaSelector={handleEnableAreaSelector}
            showSelectSavedAreaButton={showSelectSavedAreaButton}
            isDropZoneVisible={isDropZoneVisible}
            setIsDropZoneVisible={setIsDropZoneVisible}
          />
        )
      ) : (
        <MapGeofence
          selectedGeofence={selectedGeofence || coordinates || []}
          handleDrawingMode={
            isLocationLocked ? undefined : handleDrawingModeWithFormValues
          }
          clearGeofence={isLocationLocked ? undefined : handleClearGeofence}
          t={t}
          hideEditButtons={areaSelectorVisible || isLocationLocked}
          hideSaveAreaButton={hideSaveAreaButtonOnMap}
          isGeofenceInvalid={isGeofenceInvalid}
          setFieldValue={setFieldValue}
        />
      )}
    </>
  );
};
